"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_PRICES_PRODUCTION_MODE = exports.PRODUCT_PRICES_TEST_MODE = void 0;
const PRODUCT_INFO = {
    brand: {
        name: "Brand",
        price: 499,
        description: "For brands managing their own media buying",
        features: [
            "Connects to Meta, Google, and TikTok ads",
            "Will Bot, the AI marketing Agent",
            "Slack and Teams integration",
            "24/7 Always Monitoring Mode",
            "Creative Vision AI",
            "Instant Reporting",
            "Dedicated support",
            "100% Money back guarantee",
        ],
    },
    agency: {
        name: "Agency",
        price: "Custom",
        description: "For agencies managing multiple client accounts",
        includedClients: 3,
        features: [
            "Supports 3 clients",
            "Connects to Meta, Google, and TikTok ads",
            "Will Bot, the AI marketing Agent",
            "Slack and Teams integration",
            "24/7 Always Monitoring Mode",
            "Creative Vision AI",
            "Instant Reporting",
            "Dedicated support",
        ],
    },
    additionalSeat: {
        // DEPRECATED - This is no longer handled by stripe since Agency plans are now custom pricing handled by sales team
        name: "Additional Client Seat",
        price: 150,
        description: "Add more client seats to your agency subscription",
    },
    // Enterprise plan is not part of stripe subscriptions
    enterprise: {
        name: "Enterprise",
        price: "Custom",
        description: "For large organizations with unique needs",
        features: [
            "Custom Ad Accounts",
            "Dedicated onboarding and CSM",
            "Bespoke data integration",
            "Early access to pilot features",
            "Connects to Meta, Google, and TikTok ads",
            "Will Bot, the AI marketing Agent",
            "Slack and Teams integration",
            "24/7 Always Monitoring Mode",
            "Creative Vision AI",
            "Instant Reporting",
            "Dedicated support",
        ],
    },
};
exports.PRODUCT_PRICES_TEST_MODE = {
    brand: Object.assign(Object.assign({}, PRODUCT_INFO.brand), { productId: "prod_S2rNwJmSdoyyOb", priceId: "price_1REs5NG426V5LsU0REqrPOJz" }),
    agency: Object.assign(Object.assign({}, PRODUCT_INFO.agency), { productId: "prod_S2rMlXy3sFAC10", priceId: "price_1R8ldZG426V5LsU0cI7c832R" }),
    additionalSeat: Object.assign(Object.assign({}, PRODUCT_INFO.additionalSeat), { productId: "prod_S2rNSStWg0PAMy", priceId: "price_1R8leIG426V5LsU0w20tmepS" }),
    // Enterprise plan is not part of stripe subscriptions
    enterprise: PRODUCT_INFO.enterprise,
};
exports.PRODUCT_PRICES_PRODUCTION_MODE = {
    brand: Object.assign(Object.assign({}, PRODUCT_INFO.brand), { productId: "prod_S3KdUGDwCANc6h", priceId: "price_1RGUuKG426V5LsU0JPibDi1G" }),
    agency: Object.assign(Object.assign({}, PRODUCT_INFO.agency), { productId: "prod_S3KddgGsEwnN5e", priceId: "price_1R9DyeG426V5LsU0swEIyryl" }),
    additionalSeat: Object.assign(Object.assign({}, PRODUCT_INFO.additionalSeat), { productId: "prod_S3KdC4wIjeZFbl", priceId: "price_1R9DycG426V5LsU0i00o6g96" }),
    // Enterprise plan is not part of stripe subscriptions
    enterprise: PRODUCT_INFO.enterprise,
};
